import { render, staticRenderFns } from "./ReporteCobranzaAIG.vue?vue&type=template&id=4f215ff2"
import script from "./ReporteCobranzaAIG.vue?vue&type=script&lang=js"
export * from "./ReporteCobranzaAIG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports